import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createWrapper } from "next-redux-wrapper";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import appReducer from "./app";
import cartReducer from "./cart";
import userReducer from "./user";
import mobilePopupReducer from "./mobilePopup";

let clientStore: any;

const rootReducer = combineReducers({
  app: appReducer,
  cart: cartReducer,
  mobilePopup: mobilePopupReducer,
  user: userReducer,
});

const makeStore = () => {
  const isServer = typeof window === "undefined";

  if (isServer) {
    return configureStore({
      reducer: rootReducer,
      devTools: true,
      middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: false,
        }),
    });
  } else {
    if (!clientStore) {
      const persistConfig = {
        key: "points-mall2-client",
        whitelist: ["app", "cart", "mobilePopup", "user"],
        storage,
      };

      const persistedReducer = persistReducer(persistConfig, rootReducer);

      clientStore = configureStore({
        reducer: persistedReducer,
        devTools: process.env.NODE_ENV !== "production",
        middleware: (getDefaultMiddleware) =>
          getDefaultMiddleware({
            serializableCheck: false,
          }),
      });

      // @ts-ignore
      clientStore.__persistor = persistStore(clientStore);
    }

    return clientStore;
  }
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export const wrapper = createWrapper(makeStore);

export { clientStore };
